import { render } from "./ConversationPopup.vue?vue&type=template&id=25204d3f&scoped=true"
import script from "./ConversationPopup.vue?vue&type=script&lang=js"
export * from "./ConversationPopup.vue?vue&type=script&lang=js"

import "./ConversationPopup.vue?vue&type=style&index=0&id=25204d3f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25204d3f"]])

export default __exports__